import React from "react";
import CertificateExampleImg from "@/public/bg-images/example-certificate-verified.webp";
import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";

interface CertificateImageProps {
  width?: number;
  height?: number;
}

export default function CertificateImage({
  width = 500,
  height = 342,
}: CertificateImageProps) {
  const t = useTranslations("Common");
  return (
    <div className="flex items-center justify-center md:min-w-[400px] xl:shrink-0">
      <Image
        src={CertificateExampleImg}
        alt={t("certificateExample")}
        width={width}
        height={height}
      />
    </div>
  );
}
